/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import http from '../common/http-auth';

const BASE = '/template/aivalidation';

export interface ValidateHtmlPayload {
  task: string;
  html: string;
  templateId: string;
  callbackUrl: string;
  createdBy: number;
}

export const aiValidationWakeup = async () => {
  return http.get(`${BASE}/wakeup`);
};

export const aiValidationValidateHtml = async (payload: ValidateHtmlPayload) => {
  return http.post(`${BASE}/validatehtml`, payload);
};

export const aiValidationGetJob = async (jobId: string) => {
  return http.get(`${BASE}/validationstatus/${jobId}`);
};

export const aiValidationGetDetails = async (templateUId: string) => {
  return http.get(`${BASE}/validationdetails`, { params: { templateUId } });
};

export interface ValidationFeedbackEntry {
  index: number;
  question: string;
  type: string;
  options: string[];
  response: string;
}

export interface SaveValidationResultPayload {
  templateUId: string;
  jobId: string;
  issueKey: string;
  issue: {
    category: string;
    label: string;
    description: string;
    location: Record<string, unknown>;
    needs_followup: boolean | null;
    followup: {
      text: string;
      type: string;
      options: string[];
    }[];
  };
  customerFeedback: ValidationFeedbackEntry[];
  followupResponses: Record<string, string>;
  updatedValidationJson: Record<string, unknown>;
  timestamp: string;
}

export interface SaveIssuesFeedbackPayload {
  status: string;
  templateUId: string;
  jobId: string;
  data: {
    summary: {
      total_issues: number;
      followup_count: number;
      categories: Record<string, number>;
      validators_success: number;
      validators_fail: number;
    };
    issues: {
      category: string;
      label: string;
      description: string;
      needs_followup: boolean | null;
      location: {
        tag?: string;
        start_line?: number;
        end_line?: number;
      };
      followup: {
        text: string;
        type: string;
        options?: string[];
        Value: string;
      }[];
    }[];
  };
  transactionId: string;
}


export const aiValidationSaveResult = async (payload: SaveValidationResultPayload) => {
  return http.post(`${BASE}/webhooks/validationdetails`, payload);
};

export const aiValidationSaveIssuesFeedback = async (payload: SaveIssuesFeedbackPayload) => {
  const sanitizedPayload: SaveIssuesFeedbackPayload = {
    status: payload.status,
    templateUId: payload.templateUId,
    jobId: payload.jobId,
    data: payload.data,
    transactionId: payload.transactionId,
  };

  return http.post(`${BASE}/savevalidationfeedback`, sanitizedPayload);
};
